<script>
import Checkbox from 'element-ui/lib/checkbox';

export default Checkbox;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/checkbox.css';
@import '../../stylesheets/utils/utils';

/* @import "../../stylesheets/element-theme/checkbox-group.css";*/

.el-checkbox {
  $el-checkbox: '.el-checkbox';
  @include breakpoint(small down) {
    white-space: normal !important;
  }
  @include rtl() {
    &:not(:last-child) {
      margin-left: 30px;
    }

    &:last-child {
      margin-left: 0;
    }

    &__label {
      padding-right: 5px;
      padding-left: 0;
    }

    &__inner::after {
      left: auto;
      right: 4px;
    }
  }
}
</style>
